<div class="stream-item-comment">
  <div class="stream-item-comment-image">
    <!-- TODO: User image if available instead of icon -->
    <va-icon [iconName]="username" [diameter]="iconSize" [matTooltip]="username"></va-icon>
  </div>
  <div class="stream-item-comment-text">
    <span class="comment-user-name">{{ username }}</span>
    {{ comment.text }}
    <div class="stream-item-comment-meta">
      <span>{{ comment.created | date : 'MMM dd, y - h:mm a' }} ({{ fromNow(comment.created) }})</span>
    </div>
  </div>
</div>
